import React from "react";
import PrimaryButton from "./PrimaryButton";

const BUTTON_HEIGHT = 30;

/**
 * Remove Note button component
 */
const RemoveNoteButton = ({ onClick }) => {
  return (
    <div style={{ marginTop: "16px" }}>
      <PrimaryButton
        onClick={onClick}
        variant="danger"
        width="100%"
        height={BUTTON_HEIGHT}
      >
        Remove Note
      </PrimaryButton>
    </div>
  );
};

export default RemoveNoteButton;
